// extracted by mini-css-extract-plugin
export default {"above":"_14BiZ","headerTitle":"_37yE7","headerSubtitle":"_238ro","headerImage":"_3LnwI","content":"_2lRkC"};